module.exports = __webpack_public_path__ + "img/hamburger.a627e076.svg";